import { ref, readonly } from "vue";

export type UploadStatus = "idle" | "uploading" | "success" | "error";

const status = ref<UploadStatus>("idle");
const message = ref("");

let resetTimer: ReturnType<typeof setTimeout> | null = null;

function setUploading(msg = "Uploading...") {
  if (resetTimer) clearTimeout(resetTimer);
  status.value = "uploading";
  message.value = msg;
}

function setSuccess(msg = "Uploaded") {
  status.value = "success";
  message.value = msg;
  autoReset();
}

function setError(msg = "Upload failed") {
  status.value = "error";
  message.value = msg;
  autoReset();
}

function reset() {
  status.value = "idle";
  message.value = "";
}

function autoReset() {
  if (resetTimer) clearTimeout(resetTimer);
  resetTimer = setTimeout(reset, 3000);
}

export function useUploadProgress() {
  return {
    status: readonly(status),
    message: readonly(message),
    setUploading,
    setSuccess,
    setError,
    reset,
  };
}
